// extracted by mini-css-extract-plugin
export default {"folderTypeWrapper":"FolderTypeCell_folderTypeWrapper__rgM56","search":"FolderTypeCell_search__41vh0","selected":"FolderTypeCell_selected__m9Eqv"};